export default __webpack_public_path__ + "media/src/assets/images/WhiteArrow-e767165ad1d432eef6c5d5e5cef546a2.png";